import React, { useEffect } from 'react'
import { API_BASE_URL } from 'configs/AppConfig';
import { useTranslation } from "react-i18next";
import { AUTH_TOKEN } from 'redux/constants/Auth';
import axiosConfig from 'redux/sagas/initialize';

export default function Footer() {
	const { t } = useTranslation();
  useEffect(() => {
     axiosConfig.get(`${API_BASE_URL}/manage/auth/version`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        'Access-Control-Allow-Origin' : '*',
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
      }).then(response => {
      if (response?.status===200) {
         localStorage.setItem("versionNumber", response?.data);
      }
    });
 },[]);

	return (
		<footer className="footer">
			<div className="d-flex align-item-center">
				{/* <span className="ml-4">
				UI Version: {versionNumber}<br/>
				API Version: {localStorage.getItem("versionNumber")}</span> */}
			</div>
			<span>{t("impaqx.adminApp.copyright")}  &copy;  {`${new Date().getFullYear()}`} <span className="font-weight-semibold">Impaqx</span> {t("impaqx.adminApp.allRightsReserved")}</span>
			<div>
				<a className="text-gray" href="/#" onClick={e => e.preventDefault()}>{t("impaqx.adminApp.termsConditions")}</a>
				<span className="mx-2 text-muted"> | </span>
				<a className="text-gray" href="/#" onClick={e => e.preventDefault()}>{t("impaqx.adminApp.privacyPolicy")}</a>
			</div>
		</footer>
	)
}
